import { addDays, todayYmd } from './scheduleDates';

// The shared DateRangeFilter names are UI values; notification APIs take dates.
export const notificationDateRange = (preset, custom) => {
    const today = todayYmd();
    switch (preset) {
        case 'Today': return { from: today, to: today };
        case 'Yesterday': {
            const yesterday = addDays(today, -1);
            return { from: yesterday, to: yesterday };
        }
        case 'Week': return { from: addDays(today, -6), to: today };
        case 'Month': return { from: addDays(today, -29), to: today };
        case 'Custom': return custom;
        default: return { from: '', to: '' };
    }
};
